export default "__VITE_ASSET__CVvPpOnq__"